import { motion } from 'framer-motion';
import Wrapper from "global/wrappers/Wrapper";
import "swiper/css";
import "swiper/css/effect-fade";

const MiniSwipe = ({
  swiper,
  swipeItems: _swipeItems,
  includeButtons,
  currentIndex
}) => {

  let { swipeItems = [] } = swiper ?? {};
  let showButtons = true

  if (!swiper && _swipeItems) {
    swipeItems = _swipeItems
    showButtons = false
  }

  if (includeButtons) { showButtons = true }

  const content = <div className={`mini-swiper`} >
    {swipeItems.map((item, index) => (
      <motion.div
        key={index}
        initial={false}
        animate={{ opacity: currentIndex === index ? 1 : 0 }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
        style={{
          position: visualViewport === index ? 'relative' : 'absolute',
          width: '100%',
          pointerEvents: currentIndex === index ? 'auto' : 'none'
        }}
      >
        {item}
      </motion.div>
    ))}
  </div>

  return (
    <Wrapper
      // header={header}
      content={content}
    />
  )

};

export default MiniSwipe;
